import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { signOut } from "firebase/auth";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { createPopper } from '@popperjs/core';

import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap's JS includes Popper.js

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';





import "./NavBarRefresh.css";

const NavBar = () => {
  const industryLinks = [
    { to: "/ai-for-restaurants", label: "Restaurants" },
    { to: "/ai-for-salons", label: "Salons" },
    { to: "/ai-for-tradespeople", label: "Tradespeople" },
  ];

  const [user] = useAuthState(auth);
  const [users, setUsers] = useState([]);
  const [logo, setLogo] = useState([]);
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        navigate('/'); // Navigate to the home page after successful sign-out
      })
      .catch((error) => {
        console.error('Sign out error: ', error);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const logoResponse = await fetch("https://ai-automation-audit-01-e0855711738d.herokuapp.com/logo");
        const logoData = await logoResponse.json();
        setLogo(logoData);

        const usersResponse = await fetch("https://ai-automation-audit-01-e0855711738d.herokuapp.com/users");
        const usersData = await usersResponse.json();
        setUsers(usersData);

        const profileResponse = await fetch("https://ai-automation-audit-01-e0855711738d.herokuapp.com/profiles/");
        const profileData = await profileResponse.json();
        setProfile(profileData);
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };




  const button = document.querySelector('#button');
  const tooltip = document.querySelector('#tooltip');

  const popperInstance = createPopper(button, tooltip, {
    placement: 'right', // Adjust the position as needed
  });


  return (




    <>

      {
        logo.map(l => <div>
          {/* main header */}
          <header className={`main-header header-style-six ${isHomePage ? "hero-header" : ""}`}>
            {/* header-lower */}
            <div className="header-lower">
              <div className="auto-container">
                <div className="outer-box">
                  <div className="logo-box">
                    <figure className="logo mt-3"><a href="/"><img src={l.logo} alt /></a></figure>
                  </div>
                  <div className="menu-area">
                    {/*Mobile Navigation Toggler*/}
                    <div className="mobile-nav-toggler">
                      <i className="icon-bar" />
                      <i className="icon-bar" />
                      <i className="icon-bar" />
                    </div>
                    <nav className="main-menu navbar-expand-md navbar-light clearfix">
                      <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                        <ul className="navigation clearfix">

                          <li><a href="/">Home</a></li>
                          <li><a href="/#about-sec">About</a></li>
                          <li><a href="/service">Services</a></li>
                          <li className="dropdown">
                            <a href="/#">Industries</a>
                            <ul>
                              {industryLinks.map((item) => (
                                <li key={item.to}>
                                  <Link to={item.to}>{item.label}</Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                          <li><a href="/pricing">Pricing</a></li>
                          <li><a href="/support">Support</a></li>
                          <li><a href="/contact-us">Contact Us</a></li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                  <div className="menu-right-content">
                    {user?.email ? (
                      <>
                        {profile.map(
                          (pro) =>
                            pro.userEmail === user?.email && (
                              <div
                                className="nav-item dropdown mt-1 me-3"
                                key={pro._id}
                              >
                                <a
                                  className="nav-link dropdown-toggle"
                                  href="#"
                                  role="button"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img
                                    src={
                                      pro.profileImg ||
                                      "https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                                    }
                                    alt="Profile"
                                    className="rounded-circle me-2"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end p-3 mt-3">
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/dashboard"
                                    >
                                      <i className="fa-solid fa-bars text-primary"></i>{" "}
                                      Dashboard
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/my-order/"
                                    >
                                      <i className="fa-solid fa-cart-shopping text-primary"></i>{" "}
                                      My Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <i className="fa-solid fa-user text-primary"></i>{" "}
                                    {pro.userName}
                                  </li>
                                  <li>{pro.userEmail}</li>
                                  <Link
                                    to={`/update-profile/${pro._id}`}
                                    className=" mt-2 mb-2"
                                  >
                                    Edit Profile
                                    <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
                                  </Link>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={handleSignOut}
                                    >
                                      <i className="fa-solid fa-right-from-bracket text-primary"></i>
                                      Logout
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            )
                        )}
                      </>
                    ) : (
                      <ul className="list-unstyled">
                        <li className="nav-item d-flex align-items-center">
                          <Link to="/login" className="theme-btn btn-one mt-3">
                            Log in
                          </Link>
                        </li>
                      </ul>
                    )}


                    <div className="side-item">
                      {users.map(
                        (u, index) =>
                          u.userEmail === user?.email &&
                          u.userRole === "Admin" && (
                            <li className="nav-item d-flex align-items-center" key={index}>
                              <Link to="/admin" className="theme-btn btn-one">
                                Admin
                              </Link>
                            </li>
                          )
                      )}
                    </div>
                  </div>
                  <div className="d-lg-none ">
                    <a
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample"
                      role="button"
                      aria-controls="offcanvasExample"
                      className="d-lg-none"
                    >
                      <img
                        src="https://i.ibb.co.com/PZ7YV11m/screencapture-localhost-3000-2024-09-28-17-36-48.png"
                        alt="Menu"
                        style={{ width: '50px', height: 'auto' }}
                      />
                    </a>

                    <div
                      className="offcanvas offcanvas-start"
                      tabIndex="-1"
                      id="offcanvasExample"
                      aria-labelledby="offcanvasExampleLabel"
                    >
                      <div className="offcanvas-header p-4 border-bottom">
                        <h5 className="offcanvas-title fw-bold" id="offcanvasExampleLabel">
                          Menu
                        </h5>
                        <button
                          type="button"
                          className="btn-close text-reset"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="offcanvas-body p-4">
                        <ul className="navbar-nav text-start">
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/"
                            >
                              <i className="bi bi-house-door me-2"></i> Home
                            </a>
                          </li>
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/#about-sec"
                            >
                              <i className="bi bi-info-circle me-2"></i> About
                            </a>
                          </li>
                         
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/service"
                            >
                              <i className="bi bi-wrench me-2"></i> Services
                            </a>
                          </li>
                          {industryLinks.map((item) => (
                            <li className="nav-item shadow-sm border rounded mb-3" key={item.to}>
                              <Link
                                className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                                to={item.to}
                              >
                                <i className="bi bi-grid me-2"></i> {item.label}
                              </Link>
                            </li>
                          ))}
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/pricing"
                            >
                              <i className="bi bi-currency-dollar me-2"></i> Pricing
                            </a>
                          </li>
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/support"
                            >
                              <i className="bi bi-life-preserver me-2"></i> Support
                            </a>
                          </li>
                          <li className="nav-item shadow-sm border rounded mb-3">
                            <a
                              className="nav-link text-dark fw-semibold py-2 close-offcanvas"
                              href="/contact-us"
                            >
                              <i className="bi bi-envelope me-2"></i> Contact Us
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*sticky Header*/}
            <div className="sticky-header">
              <div className="auto-container">
                <div className="outer-box">
                  <div className="logo-box">
                    <figure className="logo "><a href="/"><img src={l.logo} alt /></a></figure>
                  </div>
                  <div className="menu-area">
                    <nav className="main-menu clearfix">
                      <ul className="navigation clearfix">

                        <li><a href="/">Home</a></li>
                        <li><a href="/#about-sec">About</a></li>
                        <li><a href="/service">Services</a></li>
                        <li className="dropdown">
                          <a href="/#">Industries</a>
                          <ul>
                            {industryLinks.map((item) => (
                              <li key={item.to}>
                                <Link to={item.to}>{item.label}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li><a href="/pricing">Pricing</a></li>
                        <li><a href="/support">Support</a></li>
                        <li><a href="/contact-us">Contact Us</a></li>

                      </ul>
                    </nav>
                  </div>
                  <div className="menu-right-content">
                    {user?.email ? (
                      <>
                        {profile.map(
                          (pro) =>
                            pro.userEmail === user?.email && (
                              <div
                                className="nav-item dropdown mt-1 me-3"
                                key={pro._id}
                              >
                                <a
                                  className="nav-link dropdown-toggle"
                                  href="#"
                                  role="button"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img
                                    src={
                                      pro.profileImg ||
                                      "https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                                    }
                                    alt="Profile"
                                    className="rounded-circle me-2"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end p-3 mt-3">
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/dashboard"
                                    >
                                      <i className="fa-solid fa-bars text-primary"></i>{" "}
                                      Dashboard
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/my-order/"
                                    >
                                      <i className="fa-solid fa-cart-shopping text-primary"></i>{" "}
                                      My Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <i className="fa-solid fa-user text-primary"></i>{" "}
                                    {pro.userName}
                                  </li>
                                  <li>{pro.userEmail}</li>
                                  <Link
                                    to={`/update-profile/${pro._id}`}
                                    className=" mt-2 mb-2"
                                  >
                                    Edit Profile
                                    <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
                                  </Link>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={handleSignOut}
                                    >
                                      <i className="fa-solid fa-right-from-bracket text-primary"></i>
                                      Logout
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            )
                        )}
                      </>
                    ) : (
                      <ul className="list-unstyled">
                        <li className="nav-item d-flex align-items-center">
                          <Link to="/login" className="theme-btn btn-one mt-3">
                            Log in
                          </Link>
                        </li>
                      </ul>

                    )}


                    <div className="side-item">
                      {users.map(
                        (u, index) =>
                          u.userEmail === user?.email &&
                          u.userRole === "Admin" && (
                            <li className="nav-item d-flex align-items-center" key={index}>
                              <Link to="/admin" className="theme-btn btn-one">
                                Admin
                              </Link>
                            </li>
                          )
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </header>
          {/* main-header end */}
          {/* Mobile Menu  */}
          <div className="mobile-menu">


            <div />

            {user?.email ? (
              <>
                {profile.map(
                  (pro) =>
                    pro.userEmail === user?.email && (
                      <div
                        className="nav-item dropdown"
                        key={pro._id}
                      >
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img
                            src={

                              "https://i.postimg.cc/NjxGmyRC/icons8-hamburger-menu-50.png"
                            }
                            alt="Profile"

                            style={{
                              width: "40px",
                              height: "40px",

                            }}
                          />
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end p-3 mt-3">
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/dashboard"
                            >
                              <i className="fa-solid fa-bars text-primary"></i>{" "}
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/my-order/"
                            >
                              <i className="fa-solid fa-cart-shopping text-primary"></i>{" "}
                              My Orders
                            </Link>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <i className="fa-solid fa-user text-primary"></i>{" "}
                            {pro.userName}
                          </li>
                          <li>{pro.userEmail}</li>
                          <Link
                            to={`/update-profile/${pro._id}`}
                            className=""
                          >
                            Edit Profile
                            <span className=""></span>
                          </Link>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleSignOut}
                            >
                              <i className="fa-solid fa-right-from-bracket text-primary"></i>
                              Logout
                            </button>
                          </li>
                        </ul>
                      </div>
                    )
                )}
              </>
            ) : (
              <li className="nav-item" style={{ listStyleType: 'none' }}>
                <Link to="/login" className="btn btn-outline-info btn-lg mx-auto mb-2 text-decoration-none">
                  Log in
                </Link>
              </li>
            )}

          </div>{/* End Mobile Menu */}


        </div>)
      }


    </>


  );
};

export default NavBar;
